import * as User from '../../constants/User/Bank'
import axios from 'axios';

import * as SG from '../../constants/AppSettings'
import {
  signInCheck,
  noticeAdd,
  loadEnd,
  loadStart,
  noticeRemove
} from '../App';


export function noticeAddForBank(msg, type = 'success') {
  return dispatch => {
    dispatch(noticeAdd(msg, type))
  }
}

export function noticeRemoveForBank() {
  return dispatch => {
    dispatch(noticeRemove())
  }
}

export function createAccount(token, accountFormData, fileData, accountID) {
  return dispatch => {
    dispatch(loadStart())
    axios.put(SG.USER_ACCOUNT_FIRST_OR_CREATE_URL,
      {
        account: accountFormData,
        file: fileData,
        token: token
      }
        , {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
      dispatch(getBankInfo())
      dispatch(noticeAdd('口座情報をStripeに送信しました', 'success'))
      dispatch(loadEnd())
    }).catch(res => {
        dispatch(noticeAdd('アカウント作成に失敗しました', 'error'))
        dispatch(loadEnd())
    })
  }
}

export function createAccountResult(res) {
  return dispatch => {
    
  }
}





export function createBank(token, fileData) {
  return dispatch => {
    dispatch(loadStart())

    // axios.post(SG.USER_BANK_REGIST_URL, token, {
    //   headers: {
    //     'Authorization': localStorage.getItem('token')
    //   }
    // }).then((res) => {
    //   // dispatch(loadEnd())
    //   dispatch(createBankResult(res.data))

    // }).catch((res) => {
    //   dispatch(noticeAdd('登録失敗', 'error'))
    //   console.log('Bank登録失敗', res)
    //   dispatch(loadEnd())
    // })
    return {
      type: User.BANK_REGIST
    }
  }
}

export function createBankResult(result) {
  return {
    type: User.BANK_REGIST_RESULT,
    result
  }
}

export function deleteBank() {
  return dispatch => {
    dispatch(loadStart())
    dispatch(loadEnd())
    // axios.
  }
}

export function getBankInfo() {
  return dispatch => {
    dispatch(loadStart())

    axios.get(SG.USER_ACCOUNT_INDEX_URL, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then((r) => {
      dispatch(loadEnd())
      dispatch(getBankInfoResult(r.data.accounts[0]))
    }).catch((r) => {
      dispatch(loadEnd())
    })
  }
}

export function afterGetCreateAccount() {
  return dispatch => {
    dispatch(loadStart())

    axios.post(SG.USER_ACCOUNT_CREATE_URL, {}, {
      headers: {
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {
      dispatch(loadEnd())
      getBankInfo()
    }).catch(res => {
      dispatch(loadEnd())
    })
  }
}

export function getBankInfoResult(account) {
  return {
    type: User.BANK_INFO_GET_RESULT,
    account
  }
}

export function getBankInfoReset() {
  return {
    type: User.BANK_INFO_GET_RESET
  }
}


// WEBPACK FOOTER //
// ./src/actions/User/Bank.js